import { LegalConfig } from 'src/widgets/legal';

export const legalConfig: LegalConfig = {
  BANK_NAME: 'АО "ТИНЬКОФФ БАНК"',
  BIC: '044525974',
  CHECKING_ACCOUNT: '40701810900000005788',
  CORRESPONDENT_ACCOUNT: '30101810145250000974',
  DIRECTOR_NAME: 'Титов Андрей Владимирович',
  INN: '5903143979',
  KPP: '590301001',
  LEGAL_ADDRESS: '614077, Пермский край, г. Пермь, ул Пушкарская, Д. 140, офис 407А',
  POSTAL_ADDRESS: '614077, Пермский край, г. Пермь, ул Пушкарская, Д. 140, офис 407А',
  LEGAL_NAME: 'ООО «ЮХЕЛП»',
  LEGAL_NAME_FULL: 'Общество с ограниченной ответственностью «ЮХЕЛП»',
  OGRN: '1195958039859',
  OKPO: '42547132',
  PHONE: ' +7 (800) 301-76-15',
};
